module.exports = __webpack_public_path__ + "static/media/medal-wooden.e4fdf787.png";